import * as React from "react";

const renderers = [];
let recaptchaId = null;

export default class ReCAPTCHA extends React.Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleErrored = this.handleErrored.bind(this);
    this.injectScript = this.injectScript.bind(this);
    this.createRecaptcha = this.createRecaptcha.bind(this);
    this.destroyRecaptcha = this.destroyRecaptcha.bind(this);
    this.handleRecaptchaRef = this.handleRecaptchaRef.bind(this);
  }

  injectScript() {
    window.GoogleRecaptchaLoaded = () => {
      while (renderers.length) {
        const renderer = renderers.pop();
        renderer();
      }
    };

    const script = document.createElement('script');
    script.id = 'recaptcha';
    script.src = `https://www.recaptcha.net/recaptcha/api.js?onload=GoogleRecaptchaLoaded&render=explicit`;
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.onerror = function (error) { throw error; };
    document.body.appendChild(script);
    const $style = document.createElement('style');
    if (!document.querySelector(`style[id="grecaptcha-style"]`)) {
      $style.id = 'grecaptcha-style';
      $style.innerHTML = '.grecaptcha-badge{visibility: hidden;}';
      document.head.appendChild($style);
    }
  }

  execute() {
    if (window.grecaptcha && recaptchaId!==undefined) {
      return window.grecaptcha.execute(recaptchaId);
    } else {
      this._executeRequested = true;
    }
  }
  
  getRecaptchaToken() {
    this.reset();
    return new Promise((resolve, reject) => {
      this.executionResolve = resolve;
      this.executionReject = reject;
      this.execute();
    });
  }

  reset() {
    if (window.grecaptcha && recaptchaId!==undefined) {
      window.grecaptcha.reset(recaptchaId);
    }
  }

  handleErrored(error) {
    if (this.props.onErrored) {
      this.props.onErrored();
    }
    if (this.executionReject) {
      if (error === undefined) error = 'Invalid request';
      this.executionReject(error);
      delete this.executionResolve;
      delete this.executionReject;
    }
  }

  handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }
    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  }

  createRecaptcha() {
    const loaded = () => {
      if (this.captcha) {
        const wrapper = document.createElement("div");
        recaptchaId = window.grecaptcha.render(wrapper, {
          sitekey: this.props.sitekey,
          size: 'invisible',
          badge: 'bottomleft',
          callback: this.handleChange,
          "expired-callback": this.handleChange(null),
          "error-callback": this.handleErrored,
        });
        this.captcha.appendChild(wrapper);
      }
    };

    if (+process.env.RECAPTCHA_ENABLED) {
      if (window.grecaptcha && window.grecaptcha.render && recaptchaId===undefined) {
        loaded();
      } else {
        renderers.push(loaded);
        if (!document.querySelector('#recaptcha')) {
          this.injectScript();
        }
      }
    }

    if (this._executeRequested && window.grecaptcha && recaptchaId!==undefined) {
      this._executeRequested = false;
      this.execute();
    }
  }

  destroyRecaptcha() {
    if (this.captcha && window.grecaptcha) {
      while (this.captcha.firstChild) {
        this.captcha.removeChild(this.captcha.firstChild);
      }
      window.grecaptcha.reset(recaptchaId);
      delete window['grecaptcha'];
    }
    const removeStyles = document.querySelector(`style[id="grecaptcha-style"]`);
    if (removeStyles) document.head.removeChild(removeStyles);
    const removeScripts = document.querySelector(`script[id="recaptcha"]`);
    if (removeScripts) document.body.removeChild(removeScripts);
  }

  componentDidMount() {
    this.createRecaptcha();
  }

  componentDidUpdate() {
    this.createRecaptcha();
  }
  
  componentWillUnmount() {
    this.destroyRecaptcha();
  }

  handleRecaptchaRef(elem) {
    this.captcha = elem;
  }

  render() {
    const {
      sitekey,
      onChange,
      theme,
      type,
      tabindex,
      onExpired,
      onErrored,
      size,
      stoken,
      badge,
      hl,
      isolated,
      ...childProps
    } = this.props;

    return <div className="form-row-recaptcha">
      This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        <div {...childProps} ref={this.handleRecaptchaRef} />
      </div>;
  }
}

ReCAPTCHA.displayName = "ReCAPTCHA";



// WEBPACK FOOTER //
// ./src/components/ReCaptcha.js